export enum STATUS {
  OPEN = "OPEN",
  BLANK = "BLANK",
  RESERVE = "RESERVE",
  CONTRACT = "CONTRACT",
  DELETED = "DELETED",
  NON_INFO = "NON_INFO",
}

export const stall_status: {
  label: string;
  value: string;
}[] = [
    {
      label: "เปิดให้จอง",
      value: STATUS.OPEN,
    },
    {
      label: "ว่าง",
      value: STATUS.BLANK,
    },
    {
      label: "สำรอง",
      value: STATUS.RESERVE,
    },
    {
      label: "ทำสัญญาแล้ว",
      value: STATUS.CONTRACT,
    },
    {
      label: "ลบ",
      value: STATUS.DELETED,
    },
    {
      label: "ข้อมูลไม่ครบ",
      value: STATUS.NON_INFO,
    },

  ]

export const renderStatus = (value: string, string_other?: string): string => {
  return (
    `${stall_status.find((x) => x.value === value)?.label ||
    stall_status.find((x) =>
      x.value.split(',').includes(value)
    )?.label ||
    ""}${string_other || ""}`
  )
};


